module.exports = __webpack_public_path__ + "static/quicksand-v9-latin-regular-d8b2688a6b382bdbdfeeae67ea6579c7.woff2";